import "core-js/modules/es.reflect.to-string-tag.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { defaultLogger } from './logger.mjs';
import { notifyManager } from './notifyManager.mjs';
import { Removable } from './removable.mjs';
import { createRetryer, canFetch } from './retryer.mjs';

// CLASS
var Mutation = /*#__PURE__*/function (_Removable) {
  _inherits(Mutation, _Removable);
  var _super = _createSuper(Mutation);
  function Mutation(config) {
    var _this;
    _classCallCheck(this, Mutation);
    _this = _super.call(this);
    _this.defaultOptions = config.defaultOptions;
    _this.mutationId = config.mutationId;
    _this.mutationCache = config.mutationCache;
    _this.logger = config.logger || defaultLogger;
    _this.observers = [];
    _this.state = config.state || getDefaultState();
    _this.setOptions(config.options);
    _this.scheduleGc();
    return _this;
  }
  _createClass(Mutation, [{
    key: "setOptions",
    value: function setOptions(options) {
      this.options = _objectSpread(_objectSpread({}, this.defaultOptions), options);
      this.updateCacheTime(this.options.cacheTime);
    }
  }, {
    key: "meta",
    get: function get() {
      return this.options.meta;
    }
  }, {
    key: "setState",
    value: function setState(state) {
      this.dispatch({
        type: 'setState',
        state: state
      });
    }
  }, {
    key: "addObserver",
    value: function addObserver(observer) {
      if (!this.observers.includes(observer)) {
        this.observers.push(observer); // Stop the mutation from being garbage collected

        this.clearGcTimeout();
        this.mutationCache.notify({
          type: 'observerAdded',
          mutation: this,
          observer: observer
        });
      }
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });
      this.scheduleGc();
      this.mutationCache.notify({
        type: 'observerRemoved',
        mutation: this,
        observer: observer
      });
    }
  }, {
    key: "optionalRemove",
    value: function optionalRemove() {
      if (!this.observers.length) {
        if (this.state.status === 'loading') {
          this.scheduleGc();
        } else {
          this.mutationCache.remove(this);
        }
      }
    }
  }, {
    key: "continue",
    value: function _continue() {
      var _this$retryer$continu, _this$retryer;
      return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;
        var executeMutation, restored, _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3, _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options, context, data, _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              executeMutation = function executeMutation() {
                var _this$options$retry;
                _this2.retryer = createRetryer({
                  fn: function fn() {
                    if (!_this2.options.mutationFn) {
                      return Promise.reject('No mutationFn found');
                    }
                    return _this2.options.mutationFn(_this2.state.variables);
                  },
                  onFail: function onFail(failureCount, error) {
                    _this2.dispatch({
                      type: 'failed',
                      failureCount: failureCount,
                      error: error
                    });
                  },
                  onPause: function onPause() {
                    _this2.dispatch({
                      type: 'pause'
                    });
                  },
                  onContinue: function onContinue() {
                    _this2.dispatch({
                      type: 'continue'
                    });
                  },
                  retry: (_this$options$retry = _this2.options.retry) != null ? _this$options$retry : 0,
                  retryDelay: _this2.options.retryDelay,
                  networkMode: _this2.options.networkMode
                });
                return _this2.retryer.promise;
              };
              restored = this.state.status === 'loading';
              _context.prev = 2;
              if (restored) {
                _context.next = 11;
                break;
              }
              this.dispatch({
                type: 'loading',
                variables: this.options.variables
              }); // Notify cache callback
              _context.next = 7;
              return (_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this);
            case 7:
              _context.next = 9;
              return (_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables);
            case 9:
              context = _context.sent;
              if (context !== this.state.context) {
                this.dispatch({
                  type: 'loading',
                  context: context,
                  variables: this.state.variables
                });
              }
            case 11:
              _context.next = 13;
              return executeMutation();
            case 13:
              data = _context.sent;
              _context.next = 16;
              return (_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this);
            case 16:
              _context.next = 18;
              return (_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context);
            case 18:
              _context.next = 20;
              return (_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this);
            case 20:
              _context.next = 22;
              return (_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context);
            case 22:
              this.dispatch({
                type: 'success',
                data: data
              });
              return _context.abrupt("return", data);
            case 26:
              _context.prev = 26;
              _context.t0 = _context["catch"](2);
              _context.prev = 28;
              _context.next = 31;
              return (_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, _context.t0, this.state.variables, this.state.context, this);
            case 31:
              if (process.env.NODE_ENV !== 'production') {
                this.logger.error(_context.t0);
              }
              _context.next = 34;
              return (_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, _context.t0, this.state.variables, this.state.context);
            case 34:
              _context.next = 36;
              return (_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, _context.t0, this.state.variables, this.state.context, this);
            case 36:
              _context.next = 38;
              return (_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, _context.t0, this.state.variables, this.state.context);
            case 38:
              throw _context.t0;
            case 39:
              _context.prev = 39;
              this.dispatch({
                type: 'error',
                error: _context.t0
              });
              return _context.finish(39);
            case 42:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 26], [28,, 39, 42]]);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    key: "dispatch",
    value: function dispatch(action) {
      var _this3 = this;
      var reducer = function reducer(state) {
        switch (action.type) {
          case 'failed':
            return _objectSpread(_objectSpread({}, state), {}, {
              failureCount: action.failureCount,
              failureReason: action.error
            });
          case 'pause':
            return _objectSpread(_objectSpread({}, state), {}, {
              isPaused: true
            });
          case 'continue':
            return _objectSpread(_objectSpread({}, state), {}, {
              isPaused: false
            });
          case 'loading':
            return _objectSpread(_objectSpread({}, state), {}, {
              context: action.context,
              data: undefined,
              failureCount: 0,
              failureReason: null,
              error: null,
              isPaused: !canFetch(_this3.options.networkMode),
              status: 'loading',
              variables: action.variables
            });
          case 'success':
            return _objectSpread(_objectSpread({}, state), {}, {
              data: action.data,
              failureCount: 0,
              failureReason: null,
              error: null,
              status: 'success',
              isPaused: false
            });
          case 'error':
            return _objectSpread(_objectSpread({}, state), {}, {
              data: undefined,
              error: action.error,
              failureCount: state.failureCount + 1,
              failureReason: action.error,
              isPaused: false,
              status: 'error'
            });
          case 'setState':
            return _objectSpread(_objectSpread({}, state), action.state);
        }
      };
      this.state = reducer(this.state);
      notifyManager.batch(function () {
        _this3.observers.forEach(function (observer) {
          observer.onMutationUpdate(action);
        });
        _this3.mutationCache.notify({
          mutation: _this3,
          type: 'updated',
          action: action
        });
      });
    }
  }]);
  return Mutation;
}(Removable);
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}
export { Mutation, getDefaultState };